import { useContext } from 'react';
import { TrackingContext, TrackingContextProps } from 'src/providers/TrackingContextProvider';

export const useTrackingContext = (): TrackingContextProps => {
  return useContext(TrackingContext);
};
